"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALPHA__DrawerHeaderChild = exports.ALPHA__DrawerHeader = exports.ALPHA__DrawerFooter = exports.ALPHA__Drawer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _drawerModule = _interopRequireDefault(require("./drawer.module.scss"));
var _env = _interopRequireDefault(require("../../../utils/env/env"));
var _IconButton = require("../../../elements/button/IconButton");
var _Button = require("../../../elements/button/Button");
var _ChevronLeft24PxOutlined = require("../../../elements/icons-jb/ChevronLeft24PxOutlined");
var _Close32PxOutlined = require("../../../elements/icons-jb/Close32PxOutlined");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ALPHA__DrawerComponent = function ALPHA__DrawerComponent(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$isDrawerLeft = _ref.isDrawerLeft,
    isDrawerLeft = _ref$isDrawerLeft === void 0 ? true : _ref$isDrawerLeft,
    _ref$hideCloseButton = _ref.hideCloseButton,
    hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
    _ref$showBackButton = _ref.showBackButton,
    showBackButton = _ref$showBackButton === void 0 ? false : _ref$showBackButton,
    _ref$disableControls = _ref.disableControls,
    disableControls = _ref$disableControls === void 0 ? false : _ref$disableControls,
    _ref$isHeaderFixed = _ref.isHeaderFixed,
    isHeaderFixed = _ref$isHeaderFixed === void 0 ? true : _ref$isHeaderFixed,
    _ref$isFooterFixed = _ref.isFooterFixed,
    isFooterFixed = _ref$isFooterFixed === void 0 ? true : _ref$isFooterFixed,
    _ref$useDefaultConten = _ref.useDefaultContentStyles,
    useDefaultContentStyles = _ref$useDefaultConten === void 0 ? true : _ref$useDefaultConten,
    header = _ref.header,
    onClose = _ref.onClose,
    onBack = _ref.onBack,
    footerChildren = _ref.footerChildren,
    headerCount = _ref.headerCount,
    headerStyleModifier = _ref.headerStyleModifier,
    className = _ref.className,
    contentClassName = _ref.contentClassName,
    footerClassName = _ref.footerClassName,
    children = _ref.children,
    onAfterClose = _ref.onAfterClose,
    headerChildTitle = _ref.headerChildTitle,
    _ref$closeButtonText = _ref.closeButtonText,
    closeButtonText = _ref$closeButtonText === void 0 ? 'Close' : _ref$closeButtonText,
    _ref$backButtonText = _ref.backButtonText,
    backButtonText = _ref$backButtonText === void 0 ? 'Back' : _ref$backButtonText,
    _ref$isNarrow = _ref.isNarrow,
    isNarrow = _ref$isNarrow === void 0 ? true : _ref$isNarrow,
    buttonInHeaderName = _ref.buttonInHeaderName,
    onButtonInHeaderClick = _ref.onButtonInHeaderClick,
    onAfterOpen = _ref.onAfterOpen,
    isOffersDrawer = _ref.isOffersDrawer,
    _ref$isLegacySPDPDraw = _ref.isLegacySPDPDrawer,
    isLegacySPDPDrawer = _ref$isLegacySPDPDraw === void 0 ? false : _ref$isLegacySPDPDraw;
  var drawerFooterRef = (0, _react.useRef)(null);
  var drawerContentRef = (0, _react.useRef)(null);
  var rootId = 'page-root';
  (0, _react.useEffect)(function () {
    var root = document.documentElement;
    var scrollbarWidth;
    var supportsScrollbarGutter = CSS.supports('(scrollbar-gutter: stable)');
    var scrollbarPresent = function scrollbarPresent() {
      scrollbarWidth = window.innerWidth - document.body.clientWidth;
      return scrollbarWidth > 0 ? true : false;
    };
    var fixScrollbarShift = function fixScrollbarShift() {
      if (!supportsScrollbarGutter && scrollbarPresent()) {
        root.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
      } else {
        return;
      }
    };
    if (isOpen) {
      fixScrollbarShift();
      root.classList.add(_drawerModule["default"].scrollbarShift);
      document.body.classList.add(_drawerModule["default"].lockBody);
    } else {
      root.classList.remove(_drawerModule["default"].scrollbarShift);
      document.body.classList.remove(_drawerModule["default"].lockBody);
    }
    if (document.getElementById(rootId) && document.getElementById(rootId) !== document.body) {
      _reactModal["default"].setAppElement("#".concat(rootId));
    } else {
      throw new Error('JLDS_ERROR_01: Missing page-root ID: The main container for the page level application is missing the required id="page-root" attribute: For more info please visit => https://prod-jl-design-system-storybook.design-system.prod.jl-digital.net/?path=/docs/errors-jlds-error-01--docs');
    }
  }, [isOpen]);
  if (_env["default"].isClient) {
    if (document.getElementById(rootId) && document.getElementById(rootId) !== document.body) {
      _reactModal["default"].setAppElement("#".concat(rootId));
    }
  }
  var onBackClick = function onBackClick() {
    !disableControls && onBack();
  };
  var onCloseClick = function onCloseClick() {
    !disableControls && onClose();
  };
  var renderHeader = function renderHeader() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ALPHA__DrawerHeader, {
      headerStyleModifier: headerStyleModifier,
      hideCloseButton: hideCloseButton,
      showBackButton: showBackButton,
      isHeaderFixed: isHeaderFixed,
      disableControls: disableControls,
      onBackClick: onBackClick,
      header: header,
      onClose: onCloseClick,
      headerCount: headerCount,
      closeButtonText: closeButtonText,
      backButtonText: backButtonText,
      isNarrow: isNarrow,
      buttonInHeaderName: buttonInHeaderName,
      onButtonInHeaderClick: onButtonInHeaderClick,
      isOffersDrawer: isOffersDrawer
    });
  };
  var renderFooter = function renderFooter() {
    return footerChildren && /*#__PURE__*/(0, _jsxRuntime.jsx)("footer", {
      id: "drawer-footer",
      "data-testid": "drawer-footer",
      ref: drawerFooterRef,
      className: (0, _classnames["default"])(_drawerModule["default"].footer, footerClassName, _defineProperty({}, _drawerModule["default"].fixFooter, isFooterFixed)),
      children: footerChildren
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactModal["default"], {
    isOpen: isOpen,
    onRequestClose: onClose,
    contentLabel: 'Drawer Modal',
    onAfterClose: onAfterClose,
    onAfterOpen: onAfterOpen,
    className: {
      base: (0, _classnames["default"])(_drawerModule["default"].Drawer, className, _defineProperty(_defineProperty(_defineProperty({}, _drawerModule["default"].left, isDrawerLeft), _drawerModule["default"].narrow, isNarrow), _drawerModule["default"].spdpLegacyDesign, isLegacySPDPDrawer)),
      afterOpen: _drawerModule["default"].DrawerAfterOpen,
      beforeClose: _drawerModule["default"].DrawerBeforeClose
    },
    overlayClassName: {
      base: _drawerModule["default"].overlay,
      afterOpen: _drawerModule["default"].overlayAfterOpen,
      beforeClose: _drawerModule["default"].overlayBeforeClose
    },
    closeTimeoutMS: 400,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _drawerModule["default"].DrawerChildren,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [isHeaderFixed && renderHeader(), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames["default"])(_drawerModule["default"].scroller, _defineProperty({}, _drawerModule["default"].scrollbarMarginRight, isDrawerLeft)),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [!isHeaderFixed && renderHeader(), headerChildTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)(ALPHA__DrawerHeaderChild, {
              title: headerChildTitle,
              isNarrow: isNarrow
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              id: "content",
              "data-testid": "drawer-content",
              ref: drawerContentRef,
              "aria-live": "polite",
              className: (0, _classnames["default"])(contentClassName, _defineProperty(_defineProperty({}, _drawerModule["default"].contentContainer, useDefaultContentStyles), _drawerModule["default"].narrow, isNarrow)),
              children: children
            }), !isFooterFixed && renderFooter()]
          })
        }), isFooterFixed && renderFooter()]
      })
    })
  });
};
var ALPHA__DrawerHeader = exports.ALPHA__DrawerHeader = function ALPHA__DrawerHeader(_ref2) {
  var headerStyleModifier = _ref2.headerStyleModifier,
    hideCloseButton = _ref2.hideCloseButton,
    _ref2$showBackButton = _ref2.showBackButton,
    showBackButton = _ref2$showBackButton === void 0 ? false : _ref2$showBackButton,
    isHeaderFixed = _ref2.isHeaderFixed,
    _ref2$disableControls = _ref2.disableControls,
    disableControls = _ref2$disableControls === void 0 ? false : _ref2$disableControls,
    onBackClick = _ref2.onBackClick,
    header = _ref2.header,
    onClose = _ref2.onClose,
    headerCount = _ref2.headerCount,
    _ref2$closeButtonText = _ref2.closeButtonText,
    closeButtonText = _ref2$closeButtonText === void 0 ? 'Close' : _ref2$closeButtonText,
    _ref2$backButtonText = _ref2.backButtonText,
    backButtonText = _ref2$backButtonText === void 0 ? 'Back' : _ref2$backButtonText,
    _ref2$isNarrow = _ref2.isNarrow,
    isNarrow = _ref2$isNarrow === void 0 ? false : _ref2$isNarrow,
    buttonInHeaderName = _ref2.buttonInHeaderName,
    onButtonInHeaderClick = _ref2.onButtonInHeaderClick,
    isOffersDrawer = _ref2.isOffersDrawer;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      className: (0, _classnames["default"])(_drawerModule["default"].header, headerStyleModifier, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _drawerModule["default"].fullWidthHeaderText, hideCloseButton && !showBackButton), _drawerModule["default"].fixHeader, isHeaderFixed), _drawerModule["default"].narrow, isNarrow), _drawerModule["default"].offersDrawer, isOffersDrawer)),
      "data-testid": "modal-header",
      children: [showBackButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _drawerModule["default"].backButton,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
          IconComponent: _ChevronLeft24PxOutlined.ChevronLeft24PxOutlinedIcon,
          disabled: disableControls,
          onClick: onBackClick,
          "data-testid": "modal-button-back",
          "aria-label": backButtonText
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames["default"])(_drawerModule["default"].title, _defineProperty({}, _drawerModule["default"].withHeaderButton, buttonInHeaderName)),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
          id: "modal-header",
          children: [header, typeof headerCount !== 'undefined' && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: (0, _classnames["default"])(_drawerModule["default"].headerCount),
            children: [' ', "(", headerCount, ")"]
          })]
        }), buttonInHeaderName && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _classnames["default"])(_drawerModule["default"].buttonInHeader),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
            onClick: onButtonInHeaderClick,
            "aria-label": buttonInHeaderName,
            small: true,
            children: buttonInHeaderName
          })
        })]
      }), !hideCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _drawerModule["default"].closeButton,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
          IconComponent: _Close32PxOutlined.Close32PxOutlinedIcon,
          disabled: disableControls,
          onClick: onClose,
          "data-testid": "modal-button-close",
          "aria-label": closeButtonText,
          size: "large"
        })
      })]
    })
  });
};
var ALPHA__DrawerHeaderChild = exports.ALPHA__DrawerHeaderChild = function ALPHA__DrawerHeaderChild(_ref3) {
  var title = _ref3.title,
    isNarrow = _ref3.isNarrow;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("header", {
    className: (0, _classnames["default"])(_drawerModule["default"].headerChild, _defineProperty({}, _drawerModule["default"].narrow, isNarrow)),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
      children: title
    })
  });
};
var ALPHA__DrawerFooter = exports.ALPHA__DrawerFooter = function ALPHA__DrawerFooter(_ref4) {
  var _ref4$hasInlineChildr = _ref4.hasInlineChildren,
    hasInlineChildren = _ref4$hasInlineChildr === void 0 ? true : _ref4$hasInlineChildr,
    footerStyleModifier = _ref4.footerStyleModifier,
    children = _ref4.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames["default"])(_drawerModule["default"].actions, footerStyleModifier, _defineProperty({}, _drawerModule["default"].stacked, !hasInlineChildren)),
    "data-testid": hasInlineChildren ? 'drawer-actions' : 'drawer-actions-stacked',
    children: children
  });
};
ALPHA__DrawerComponent.propTypes = {
  /** Toggle drawer open or closed */
  isOpen: _propTypes["default"].bool,
  /** Specifies the name of an checkbox element if used inside a form */
  onClose: _propTypes["default"].func,
  /** callback for when back button is clicked */
  onBack: _propTypes["default"].func,
  /** The content to render inside the drawer */
  children: _propTypes["default"].node,
  /** Set the slide drawer to appear on the left-hand side of the screen */
  isDrawerLeft: _propTypes["default"].bool,
  /** Header title text */
  header: _propTypes["default"].string,
  /** Header child title text */
  headerChildTitle: _propTypes["default"].string,
  /** Supply a css colour variable from colours_jb to modify header background colour eg "--grey-5" */
  /** Toggle slide drawer header  */
  isHeaderFixed: _propTypes["default"].bool,
  /** Toggle slide drawer footer  */
  isFooterFixed: _propTypes["default"].bool,
  /** adds a number in brackets next to the header text */
  headerCount: _propTypes["default"].number,
  /** a `class` modifier to override default header styles */
  headerStyleModifier: _propTypes["default"].string,
  /** hide the close button */
  hideCloseButton: _propTypes["default"].bool,
  /** show the back button */
  showBackButton: _propTypes["default"].bool,
  /** disables drawer closing when set */
  disableControls: _propTypes["default"].bool,
  /** The content to render inside the drawer footer */
  footerChildren: _propTypes["default"].node,
  /** Function that will be run after the modal has closed */
  onAfterClose: _propTypes["default"].func,
  /** Function that will be run after the modal has opened */
  onAfterOpen: _propTypes["default"].func,
  /** a `class` modifier to override default drawer styles */
  className: _propTypes["default"].string,
  /** a `class` modifier to override default container styles */
  contentClassName: _propTypes["default"].string,
  /** a `class` modifier to override default footer styles */
  footerClassName: _propTypes["default"].string,
  /** close button is just an X icon, this text is used for a11y */
  closeButtonText: _propTypes["default"].string,
  /** back button is just an < icon, this text is used for a11y */
  backButtonText: _propTypes["default"].string,
  /** Toggle narrow styling */
  isNarrow: _propTypes["default"].bool,
  /** Text to be displayed in additional header button */
  buttonInHeaderName: _propTypes["default"].string,
  /** Function to be called onClick for additional header button */
  onButtonInHeaderClick: _propTypes["default"].func,
  /** Toggle default styling of children */
  useDefaultContentStyles: _propTypes["default"].bool,
  /** Toggle offer header styling */
  isOffersDrawer: _propTypes["default"].bool
};
ALPHA__DrawerHeader.propTypes = {
  headerStyleModifier: _propTypes["default"].string,
  hideCloseButton: _propTypes["default"].bool,
  showBackButton: _propTypes["default"].bool,
  isHeaderFixed: _propTypes["default"].bool,
  disableControls: _propTypes["default"].bool,
  onBackClick: _propTypes["default"].func,
  header: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  headerCount: _propTypes["default"].number,
  closeButtonText: _propTypes["default"].string,
  backButtonText: _propTypes["default"].string,
  isNarrow: _propTypes["default"].bool,
  buttonInHeaderName: _propTypes["default"].string,
  onButtonInHeaderClick: _propTypes["default"].func,
  isOffersDrawer: _propTypes["default"].bool
};
ALPHA__DrawerHeaderChild.propTypes = {
  title: _propTypes["default"].string,
  isNarrow: _propTypes["default"].bool
};
ALPHA__DrawerFooter.propTypes = {
  /** Toggle to display footer children inline */
  hasInlineChildren: _propTypes["default"].bool,
  footerStyleModifier: _propTypes["default"].string,
  children: _propTypes["default"].arrayOf(_propTypes["default"].node)
};
var ALPHA__Drawer = exports.ALPHA__Drawer = /*#__PURE__*/(0, _react.memo)(ALPHA__DrawerComponent);